import Keypress from 'keypress.js';

export default {
  mounted() {
    this.registerMapKeyboardListeners();
  },

  beforeDestroy() {
    this.listener.unregister_combo('f');
    this.listener.unregister_combo('-');
    this.listener.unregister_combo('+');
  },

  methods: {
    registerMapKeyboardListeners() {
      this.listener = new Keypress.Listener();

      // this.listener.simple_combo('f', () => {
      //   this.toggleFilters();
      // });

      this.listener.simple_combo('-', () => {
        // console.log('Map.minus-button');
        this.setZoom((this.map.zoom -= 1));
      });

      this.listener.simple_combo('=', () => {
        // console.log('Map.plus-button');
        this.setZoom((this.map.zoom += 1));
      });
    },

    goHome() {
      // console.log('Map.goHome');
      this.setZoom(13);
      this.setCenter({
        lat: parseFloat(this.$auth.user().currentLocation.lat),
        lng: parseFloat(this.$auth.user().currentLocation.lng),
      });
    },

    worldMap() {
      // console.log('Map.worldMap');
      this.setZoom(2);
      this.setCenter({
        lat: 10.0,
        lng: 10.0,
      });
    },

    zoomChanged(newZoomLevel) {
      // console.log('Map.zoomChanged', newZoomLevel);
      this.showClusters = false;

      this.$nextTick(() => {
        this.showClusters = true;
      });
    },

    setZoom(zoom) {
      // console.log('Map.setZoom', zoom);
      this.closeInfoWindow();
      this.map.zoom = zoom;
    },

    setCenter(center) {
      // console.log('Map.setCenter.center', center);
      this.closeInfoWindow();
      this.map.center = center;
    },

    getMarkerIcon(m) {
      return `${this.$api}${m.markerIcon}`;
    },
  },
};
